import { SVGProps } from 'react';

const SvgHistoryLog = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 12" {...props}>
        <path d="M8.333 3.333h-1v3.334l2.854 1.693.48-.807-2.334-1.386V3.333ZM8 0a6 6 0 0 0-6 6H0l2.64 2.687L5.333 6h-2A4.667 4.667 0 1 1 8 10.667a4.63 4.63 0 0 1-3.293-1.374l-.947.947A5.93 5.93 0 0 0 8 12 6 6 0 1 0 8 0Z" />
    </svg>
);
export default SvgHistoryLog;
